<template>
    <div >

        <!-- map -->
        <tq-leaflet-display
            class="TQ_box_shadow TQ_padding_4px TQ_borderRadius TQ_height_bodyFullScreen_-40px TQ_borderBox"

            :p_display_lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"

            :p_map-data_c="p_questBody_c.qb_mapData_c"
            :p_polygons_ac="co_polygons_ac"

            :p_missions_ac="p_questBody_c.qb_mapMissions_ac"
            :p_mission-groups_ac="p_questBody_c.qb_mapMissionsGroup_ac"

            :p_finish-missions-indexes_an="p_questBody_c.qb_mapMissions_ac.map((qb_riddle_c,index) => {return index})"
            :p_map-mission-type_e="p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e"


            :p_map-type_e="p_questBody_c.qb_metadata_c.qbm_mapMissions_mapType2_e"

            :pf_two-fingers-movement_b="true"

            :pe_on-click-mission_f="m_clickMission_f"
            :pe_click-polygon_f="m_clickPolygon_f"
        />


        <!-- missions -->
        <div class="TQ_padding_4px TQ_bg_gray4">

            <!-- missionsGroups-->
            <component :is="co_mapGroupMissions_b ? 'tq-tabs' : 'div'"
                       :p_vertical-layout_b="true"
                       p_tabs-class_s="TQ_padding_8px_16px"
                       class="TQ_padding_4px TQ_bg_white"

                       :p_selected-tab-index_vn="p_selectedMapMissionsGroupIndex_vn"
                       p_att_s="qbmg_name_byLangCode_s"
                       :p_system_lang-code_e="p_system_langCode_e"
                       :p_display_lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"
                       :p_tabs_ao="p_questBody_c.qb_mapMissionsGroup_ac"

                       :p_title_blc_s="ass_strings.twoWords_MissionsGroups"
                       :pe_on-change-order_f="(newOrderMissionsGroups_ac) => {p_questBody_c.qb_mapMissionsGroup_ac = newOrderMissionsGroups_ac}"
                       :pe_addTab_click_f="m_addNewGroup_f">

                <!-- missionsGroup - info-->
                <div v-if="co_selectedMissionsGroup_c && co_mapGroupMissions_b" class="TQ_bg_gray4 TQ_margin_0_4px TQ_padding_16px" >

                    <!-- pointsToUnlock -->
                    <div class="TQ_margin_bottom_8px">
                        <div class="TQ_text_bold"> {{ass_strings.fourWords_pointsToUnlockLevel[p_system_langCode_e]}}</div>
                        <input type="number"
                               v-model.number="co_selectedMissionsGroup_c.qbmg_pointsToUnlock_n"
                               :placeholder="ass_strings.oneWord_points[p_system_langCode_e]"
                               class="TQ_center TQ_padding_4px TQ_margin_4px TQ_text_20px"/>

                    </div>

                    <!-- title -->
                    <div class="TQ_bg_white TQ_inline">

                        <!-- by lang code -->
                        <div class="TQ_inline TQ_maxWidth_320px TQ_margin_8px"
                             v-for="langCode_e in p_questBody_c.qb_langArr_ae"

                             :style="{'direction' : helper_getDirectionByLangCode_fe(langCode_e)}"
                             :key="langCode_e">

                            <!-- lang title-->
                            <div class="TQ_text_24px"> {{format_langCode_fs(langCode_e)}}</div>
                            <input class="TQ_input TQ_text_20px" v-model="co_selectedMissionsGroup_c.qbmg_name_byLangCode_s[langCode_e]"/>
                        </div>


                    </div>

                </div>

                <!-- missions -->
                <tq-tabs v-if="co_mapMissionsGroup_missions_ac"
                         :p_vertical-layout_b="true"
                         p_tabs-class_s="TQ_padding_8px_16px"
                         class="TQ_bg_white TQ_margin_4px"

                         :p_selected-tab-index_vn="p_selectedRiddleIndex_vn"
                         p_att_s="qbr_title_blc_s"
                         :p_system_lang-code_e="p_system_langCode_e"
                         :p_display_lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"
                         :p_tabs_ao="co_mapMissionsGroup_missions_ac"
                         :p_title_blc_s="ass_strings.oneWord_missions"

                         :p_add-tab-text_s="ass_strings.twoWords_newMission[p_system_langCode_e]"
                         :p_delete-tab_approve-text_cla_s="ass_strings.question_deleteMission"

                         :pe_delete-tab_click_f="m_removeMission_f"
                         :pe_on-change-order_f="m_changeOrderMissions_f"
                         :pe_addTab_click_f="co_polygons_area_b ? m_addNewMission_f : null">

                    <tq-riddle-data_-edit
                            v-if="co_mapMissionsGroup_missions_ac[p_selectedRiddleIndex_vn.val]"
                            :key="p_selectedRiddleIndex_vn.val"
                            :p_qb_riddle_c="co_mapMissionsGroup_missions_ac[p_selectedRiddleIndex_vn.val]"
                            :uid="co_mapMissionsGroup_missions_ac[p_selectedRiddleIndex_vn.val].qbr_riddleId_n + ''"
                            :lang-arr="p_questBody_c.qb_langArr_ae"
                            :p_system_lang-code_e="p_system_langCode_e"
                            :p_qb_display-lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"
                            :p_metadata-q-b_c="p_questBody_c.qb_metadata_c"
                            :p_show-edit-image_b="co_showMissionEditImage_fb"
                            :p_image-width-and-height_o="co_currentRiddleImageWidthAndHeight_o"
                            :p_creator-active-payment-plan_b="p_creatorActivePaymentPlan_b"

                            :pe_choose-file_f="pe_chooseFile_f"/>

                </tq-tabs>

            </component>

        </div>

    </div>
</template>

<script>
    import TqRiddleData_Edit from '../../../../components/complex/TqRiddleData_Edit'
    import {enum_mapMissionsTypes, enum_mapTypes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from "../../../../components/basic/TqCard";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqLeafletDisplay from "../../../../components/maps/TqLeafletDisplay";
    import TqTabs from "../../../../components/basic/TqTabs";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {obj_deepCopy_f} from "../../../../../functions/src/shareCode/Share_S_Obj";
    import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {helper_getDirectionByLangCode_fe, helper_getRiddleIndexWithRiddleId_fn} from "../../../../scripts/S_Helper";
    import {search_getArrObjFreeIndex} from "../../../../../functions/src/shareCode/Share_S_Search";
    import {
        FB_MapData_Polygon, FB_QuestBody,
        FB_QuestBody_MissionsGroup,
        FB_UserData
    } from "../../../../../functions/src/shareCode/Share_S_Classes";
    export default {
        name: "c_Creator_EditQuests_item_BodyMapRiddles",
        components:{
            TqTabs,
            TqLeafletDisplay,
            TqCard,
            TqRiddleData_Edit,
        },
        props:{
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_questBody_c :{
                type : FB_QuestBody,
                require: true
            },
            p_creatorActivePaymentPlan_b:{
                type: Boolean,
                require: true
            },
            pe_chooseFile_f: {},

        },
        data(){
            return{
                p_selectedMapMissionsGroupIndex_vn  : {val : null},
                p_selectedRiddleIndex_vn : {val : null},

                // import
                enum_mapMissionsTypes   : enum_mapMissionsTypes,
                helper_getDirectionByLangCode_fe   : helper_getDirectionByLangCode_fe,
                format_langCode_fs   : format_langCode_fs,
                ass_strings             : ass_strings,

            }
        },
        computed : {
            co_polygons_b(){
                return this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons
            },
            co_polygons_area_b(){
                return this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons_area
            },
            co_mapGroupMissions_b(){
                return [enum_mapMissionsTypes.polygons_area, enum_mapMissionsTypes.squares_linear_groups, enum_mapMissionsTypes.squares_linear_groups_hide].includes(this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e)
            },
            co_currentRiddleImageWidthAndHeight_o(){
                if(![enum_mapMissionsTypes.squares, enum_mapMissionsTypes.squares_linear].includes(this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e)){
                    return {
                        width  : 400,
                        height : 300,
                    }
                }

                let ans = {
                    width  : this.p_questBody_c.qb_mapMissions_ac[this.p_selectedRiddleIndex_vn.val].qbr_rectangleSize_c.mp_lng_n,
                    height : this.p_questBody_c.qb_mapMissions_ac[this.p_selectedRiddleIndex_vn.val].qbr_rectangleSize_c.mp_lat_n,
                }

                while(ans.width < 300 && ans.height < 300 ){
                    ans.width = ans.width * 10
                    ans.height = ans.height * 10
                }

                return ans
            },
            co_polygons_ac(){

                // not polygons mapMissionType
                if(this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e !== enum_mapMissionsTypes.polygons_area){
                    return this.p_questBody_c.qb_mapData_c.md_polygons_ac;
                }

                return this.p_questBody_c.qb_mapData_c.md_polygons_ac.map((polygon_c, index_n) => {

                    let newPolygon_c = new FB_MapData_Polygon(obj_deepCopy_f(polygon_c))

                    if(index_n === this.p_selectedMapMissionsGroupIndex_vn.val){
                        newPolygon_c.mdp_color_s          = 'purple'
                        newPolygon_c.mdp_strokeWidth_n    =  2
                        newPolygon_c.mdp_fillOpacity_n    =  0.4
                    }else{
                        newPolygon_c.mdp_color_s          = 'green'
                    }
                    newPolygon_c.mdp_name_s = "" + (index_n + 1)

                    return newPolygon_c
                })
            },
            co_mapMissionsGroup_missions_ac(){

                // return all map missions
                if(!this.co_mapGroupMissions_b) {
                    return this.p_questBody_c.qb_mapMissions_ac
                }

                // return group of missions
                if(this.p_selectedMapMissionsGroupIndex_vn.val == null){
                    return null
                }

                let ans_ac = []


                this.p_questBody_c.qb_mapMissionsGroup_ac[this.p_selectedMapMissionsGroupIndex_vn.val].qbmg_riddlesIds_an.forEach( (riddleId_n) =>{
                    for(let i=0; i< this.p_questBody_c.qb_mapMissions_ac.length; i++){
                        if(this.p_questBody_c.qb_mapMissions_ac[i].qbr_riddleId_n === riddleId_n){
                            ans_ac.push(this.p_questBody_c.qb_mapMissions_ac[i])
                            break;
                        }
                    }
                })

                return ans_ac
            },
            co_showMissionEditImage_fb(){
                return [enum_mapMissionsTypes.squares, enum_mapMissionsTypes.polygons_area].includes(this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e)
            },
            co_selectedMissionsGroup_c(){
                return this.p_questBody_c.qb_mapMissionsGroup_ac[this.p_selectedMapMissionsGroupIndex_vn.val]
            },
        },
        methods:{
            m_clickMission_f(missionIndex_n){
                this.p_selectedRiddleIndex_vn.val=missionIndex_n;
            },
            m_clickPolygon_f(polygonIndex_n){

                if(this.co_polygons_b){
                    this.p_selectedRiddleIndex_vn.val=polygonIndex_n;
                }else if(this.co_polygons_area_b()){
                    this.p_selectedMapMissionsGroupIndex_vn.val=polygonIndex_n;
                }
            },
            m_changeOrderMissions_f(reorderMission_ac){
                if(this.co_polygons_area_b) {
                    let reorderRiddleIds_an = reorderMission_ac.map(qb_riddle_c => {return qb_riddle_c.qbr_riddleId_n})

                    this.p_questBody_c.qb_mapMissionsGroup_ac[this.p_selectedMapMissionsGroupIndex_vn.val].qbmg_riddlesIds_an = reorderRiddleIds_an
                }else{
                    this.p_questBody_c.qb_mapMissions_ac = reorderMission_ac
                }
            },

            m_removeMission_f(tabIndex_n){

                if(this.co_polygons_area_b) {
                    let riddleId_n = this.co_mapMissionsGroup_missions_ac[tabIndex_n].qbr_riddleId_n
                    let missionIndex_n = helper_getRiddleIndexWithRiddleId_fn(this.p_questBody_c.qb_mapMissions_ac, riddleId_n)
                    let missionsGroup_riddlesIds_index_n = this.p_questBody_c.qb_mapMissionsGroup_ac[this.p_selectedMapMissionsGroupIndex_vn.val].qbmg_riddlesIds_an.indexOf(riddleId_n)

                    // remove from missions
                    this.p_questBody_c.qb_mapMissions_ac.splice(missionIndex_n, 1)

                    // remove from mission group
                    this.p_questBody_c.qb_mapMissionsGroup_ac[this.p_selectedMapMissionsGroupIndex_vn.val].qbmg_riddlesIds_an.splice(missionsGroup_riddlesIds_index_n, 1)

                }else if(this.co_polygons_b){
                    this.p_questBody_c.qb_mapMissions_ac.splice(tabIndex_n, 1)
                    this.p_questBody_c.qb_mapData_c.md_polygons_ac.splice(tabIndex_n, 1)
                }else{
                    this.p_questBody_c.qb_mapMissions_ac.splice(tabIndex_n,1)
                }
            },

            m_addNewGroup_f(){
               this.p_questBody_c.qb_mapMissionsGroup_ac.push(new FB_QuestBody_MissionsGroup({
                    qbmg_missionsGroupId_n: search_getArrObjFreeIndex(this.p_questBody_c.qb_mapMissionsGroup_ac, "qbmg_missionsGroupId_n")
                }, this.p_questBody_c.qb_langArr_ae))
            },
            m_addNewMission_f(){
                let newRiddleId_n = this.p_questBody_c.cm_qb_addMapRiddle_f()

                this.p_questBody_c.qb_mapMissionsGroup_ac[this.p_selectedMapMissionsGroupIndex_vn.val].qbmg_riddlesIds_an.push(newRiddleId_n)
            }
        },
        mounted() {


            if(this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons){
                const polygonNum_n = this.p_questBody_c.qb_mapData_c.md_polygons_ac.length
                let mapMissionsNum_n = this.p_questBody_c.qb_mapMissions_ac.length

                if(polygonNum_n > mapMissionsNum_n){
                    while(polygonNum_n !== mapMissionsNum_n){
                        mapMissionsNum_n++;
                        this.p_questBody_c.cm_qb_addMapRiddle_f()
                    }

                }else if(polygonNum_n < mapMissionsNum_n){
                    this.p_questBody_c.qb_mapMissions_ac.splice(polygonNum_n)
                }
            }


            // let firstRiddle_byGroupIndex_c = {}
            // // update riddles maps by group maps
            // this.p_questBody_c.qb_mapMissions_ac.forEach((mapMission_c) => {
            //
            //     let missionGroupIndex_n;
            //     for(missionGroupIndex_n=0; missionGroupIndex_n < this.p_questBody_c.qb_mapMissionsGroup_ac.length; missionGroupIndex_n++){
            //         if(this.p_questBody_c.qb_mapMissionsGroup_ac[missionGroupIndex_n].qbmg_riddlesIds_an.includes(mapMission_c.qbr_riddleId_n)){
            //             break;
            //         }
            //     }
            //
            //     // if(firstRiddle_byGroupIndex_c[missionGroupIndex_n] == null){
            //     //     firstRiddle_byGroupIndex_c[missionGroupIndex_n] = mapMission_c
            //     //     return;
            //     // }
            //
            //
            //
            //     // mapMission_c.qbr_mapData_c = new FB_MapData({
            //     //     md_center_c     : this.p_questBody_c.qb_mapData_c.md_center_c,
            //     //     md_zoom_n       : this.p_questBody_c.qb_mapData_c.md_zoom_n,
            //     //     md_polygons_ac  : [this.p_questBody_c.qb_mapData_c.md_polygons_ac[index_n]]
            //     // })
            //
            //     // polygon
            //     mapMission_c.qbr_mapData_c.md_polygons_ac = [this.p_questBody_c.qb_mapData_c.md_polygons_ac[missionGroupIndex_n]]
            //
            //     // from first
            //     // mapMission_c.qbr_mapData_c = firstRiddle_byGroupIndex_c[missionGroupIndex_n].qbr_mapData_c
            // })



        }

    }

</script>

<style scoped lang="scss">


</style>
